if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}
if (typeof Shopify.theme.jsAddToCart === 'undefined') {
  let listeningATC = false;
  Shopify.theme.jsAddToCart = {
    listen: () => {
      if (listeningATC) return;
      listeningATC = true;
      document.addEventListener('click', event => {
        let wasClicked = event.target;
        if ((wasClicked.matches('[data-add-to-cart]') || wasClicked.matches('[data-cartcrosssells-add]')) && !wasClicked.hasAttribute('data-default-add-to-cart-disable')) {
          event.preventDefault();
          if (Shopify.theme.settings.cart_action == 'ajaxcart') {
            event.preventDefault();

            // change styling of button or temporarily disable tpo prevent double clicks
            wasClicked.setAttribute('disabled', true);

            // get parent form
            const targetForm = wasClicked.closest('form');
            if (targetForm !== null) {
              fetch(targetForm.getAttribute('action'), {
                method: targetForm.getAttribute('method'),
                body: new URLSearchParams(new FormData(targetForm))
              }).then(() => {
                // add any animations or class changes for completion. re-enable button if disabled.
                wasClicked.classList.remove('bg-gray-600', 'cursor-not-allowed');
                wasClicked.classList.add('bg-indigo-600', 'hover:bg-indigo-700', 'focus:ring-2', 'focus:ring-offset-2', 'focus:ring-indigo-500');
                wasClicked.removeAttribute('disabled');
                Shopify.theme.jsCartCounter.update();
                Shopify.theme.jsAjaxCart.onCartChange();
                Shopify.theme.jsAjaxCart.openCart();
              }).catch(error => console.error(error));
              return false;
            }
          }
        }
      });
    }
  };
}
(() => {
  Shopify.theme.jsAddToCart.listen();
})();
